





























































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import FeedSideButton from '../classifieds/index/feeds/sidebar/FeedSideButton.vue'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import { TopLevelCategories } from '~/compositions/quick-search-menu/quick-search-menu'
import { HierarchicalCategory } from '~/models/category/types'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import CIcon from '~/components/shared/configurable/CIcon.vue'

export default defineComponent({
  components: { FeedSideButton, CCategoryIcon, CIcon },
  props: {
    categories: {
      type: Array as PropType<TopLevelCategories[] | HierarchicalCategory[]>,
      default: () => []
    },
    isSubcategoryMenu: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Object as PropType<IconDefinition>,
      required: true
    }
  },
  setup() {
    return { ciExternalLink }
  }
})
